import buildTileStyle from '@Guidelines/Component/IconTile/buildTileStyle';
import type { LucideIcon } from 'lucide-react';
import * as React from 'react';

type Props = { icon: LucideIcon; color: string };

/** Square colored tile carrying a white icon; decorative, the label sits next to it. */
const IconTile: React.FC<Props> = ({ icon: Icon, color }) => {
	const tileStyle = React.useMemo(() => buildTileStyle(color), [color]);

	return (
		<span css={tileStyle} aria-hidden="true">
			<Icon size={20} />
		</span>
	);
};

export default IconTile;
